module.exports = __webpack_public_path__ + "img/2025banner.bd94349d.jpg";